import { format, parseISO } from 'date-fns';

export function formatDateToDDMMYYYY(dateString: string): string {
  const date = parseISO(dateString);
  return format(date, 'dd/MM/yyyy');
}

export function isValidRG(rg: string): boolean {
  // Remova espaços no início e no final do RG
  rg = rg.trim();

  // Verifique se o RG tem entre 3 e 15 caracteres
  if (rg.length < 3 || rg.length > 15) {
    return false;
  }

  // Verifique se o RG contém apenas letras e números (não caracteres especiais)
  if (!/^[A-Z0-9]+$/.test(rg)) {
    return false;
  }

  // Verifique se o RG não contém números ou letras sequenciais ou repetições
  for (let i = 0; i < rg.length - 2; i++) {
    if (
      (rg[i] === rg[i + 1] && rg[i] === rg[i + 2]) ||
      (rg.charCodeAt(i + 1) === rg.charCodeAt(i) + 1 && rg.charCodeAt(i + 2) === rg.charCodeAt(i) + 2)
    ) {
      return false;
    }
  }

  return true;
}